import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="grid min-h-[70vh] place-items-center bg-ivory px-5" data-testid="payment-cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-md text-center"
      >
        <span className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-beige text-ink/70">
          <XCircle size={28} strokeWidth={1.5} />
        </span>
        <h1 className="mt-8 font-serif text-4xl font-light tracking-tight text-ink md:text-5xl">
          Payment cancelled
        </h1>
        <p className="mt-4 text-ink/60">
          No worries — your bag is still saved. You can review it and check out whenever you're ready.
        </p>
        <div className="mt-10 flex justify-center gap-4">
          <Link to="/checkout" className="rounded-full bg-ink px-8 py-4 text-[0.72rem] uppercase tracking-[0.24em] text-ivory transition-colors hover:bg-gold">
            Return to Checkout
          </Link>
          <Link to="/shop" className="rounded-full border border-ink px-8 py-4 text-[0.72rem] uppercase tracking-[0.24em] text-ink transition-colors hover:bg-ink hover:text-ivory">
            Keep Shopping
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
